import {TRANSLATION, Yup} from '@/imports-files/pages/admins/dashboard/clients/add-users';

export const CSV_FILE_SIZE_LIMIT = 1000000;


export function setAddUserInitialValues()
{

    return {
                client:{
                           client_users_attributes:[]
                        }
           };
}

export const VALIDATION_SCHEMA = Yup.object().shape({
    client: Yup.object().shape({
                                 client_users_attributes: Yup.array().of(
                                                                           Yup.object({
                                                                                        _destroy: Yup.boolean(),
                                                                                        role_id: Yup.string().when("_destroy",{
                                                                                            is: (_destroy) => !_destroy,
                                                                                            then: Yup.string().required(TRANSLATION('errors:required'))
                                                                                        }),
                                                                                        user_attributes: Yup.object().when("_destroy",{
                                                                                            is: (_destroy) =>!_destroy,
                                                                                            then: 
                                                                                                Yup.object({
                                                                                                email:Yup.string()
                                                                                                         .email(TRANSLATION('errors:invalid_email'))
                                                                                                         .required(TRANSLATION('errors:required')),
                                                                                                name: Yup.string().required(TRANSLATION('errors:required')).nullable()
                                                                                            })
                                                                                          }),
                                                                                     })
                                                                        )
                              })
  });
